module.exports = __webpack_public_path__ + "img/1880_Name-STYRIA.cf64b515.jpg";